import { GetEventsQuery } from '@diritto/common/api/EventApi';
import { QueryKey } from 'constants/reactQuery';

export const eventsQueryKey = {
  events: [QueryKey.Event] as const,
  eventList: (options: GetEventsQuery) => [...eventsQueryKey.events, options] as const,
  event: (id: number) => [...eventsQueryKey.events, id] as const,
  eventParticipated: (id: number) => [...eventsQueryKey.events, id, QueryKey.EventParticipate] as const,
};
